import React from 'react';
import { Button, Element, InputGroup, InputAddon, InputField } from '@quotient/riq-react-ui';

type TResponsiveSizes = 'small' | 'medium' | 'large';

export interface IAddItemFormProps {
  size?: number | 'small' | 'medium' | 'large' | TResponsiveSizes[];
  AddOnButton?: React.ReactElement<any, any> | null;
  onSubmit?: ({ itemName: string }) => void;
}

const AddItemForm: React.FC<IAddItemFormProps> = ({ size, onSubmit, AddOnButton }) => {
  const [itemName, setItemName] = React.useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target;
    const value = target.value;
    setItemName(value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit({ itemName });
    setItemName('');
  };

  const SubmitButton = AddOnButton || (
    <Button
      type="submit"
      variant="primary"
      size={size}
      css={{ width: '48px', fontSize: '32px', fontWeight: 'lighter', borderRadius: '0' }}
    >
      +
    </Button>
  );

  return (
    <Element
      as="form"
      component="AddItemForm"
      marginTop={2}
      css={{ position: 'sticky', top: 0, zIndex: 2, padding: 4, background: 'grays.200' }}
      onSubmit={handleSubmit}
    >
      <InputGroup size={size}>
        <InputField placeholder="Add an Item" value={itemName} onChange={handleChange} css={{ border: 'none' }} />
        <InputAddon>{SubmitButton}</InputAddon>
      </InputGroup>
    </Element>
  );
};

export { AddItemForm };
